import React, { useState } from "react";
import * as palette from "@govlaunch/palette";
import PropTypes from "prop-types";
import { validateColor, validateText, validateUrl, validateButtonWidth } from "./fieldValidation";

export default function CustomButtonInput({ onInsert }) {
  const [buttonText, setButtonText] = useState("");
  const [buttonTextTouched, setButtonTextTouched] = useState(false);
  const [buttonURL, setButtonURL] = useState("");
  const [buttonURLTouched, setButtonURLTouched] = useState(false);
  const [buttonColor, setButtonColor] = useState("#086BE5");
  const [buttonTextColor, setButtonTextColor] = useState("#FFFFFF");
  const [buttonBorderColor, setButtonBorderColor] = useState("#086BE5");
  const [buttonWidth, setButtonWidth] = useState();

  return (
    <div>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          event.stopPropagation();

          onInsert({
            buttonText: buttonText,
            buttonURL: buttonURL,
            buttonColor: buttonColor,
            buttonTextColor: buttonTextColor,
            buttonBorderColor: buttonBorderColor || buttonColor,
            buttonWidth: buttonWidth,
            buttonTargetBlank: event.target.elements.targetBlank.checked,
          });
        }}
        css={{
          width: 300,
          padding: 8,
          display: "grid",
          gridRowGap: 8,
        }}
      >
        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>Button text</span>

          <input
            type="text"
            name="buttonText"
            placeholder="Insert Button text"
            value={buttonText}
            onChange={(e) => {
              setButtonText(e.target.value);
              setButtonTextTouched(true);
            }}
            css={{
              margin: 0,
              padding: 8,
              border: "solid 1px",
              borderColor: buttonTextTouched && !validateText(buttonText) ? palette.red : palette.sealBlue,
              borderRadius: 2,
            }}
          />
        </div>

        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>URL</span>

          <input
            type="text"
            name="buttonURL"
            value={buttonURL}
            onChange={(e) => {
              setButtonURL(e.target.value);
              setButtonURLTouched(true);
            }}
            placeholder="Insert Button URL"
            css={{
              margin: 0,
              padding: 8,
              border: "solid 1px",
              borderColor: buttonURLTouched && !validateUrl(buttonURL) ? palette.red : palette.sealBlue,
              borderRadius: 2,
            }}
          />
        </div>

        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>Button color</span>

          <div
            css={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <input
              type="color"
              value={buttonColor}
              onChange={(e) => {
                setButtonColor(e.target.value);
              }}
              css={{
                height: 30,
                width: 60,
                border: "solid 1px",
                borderColor: validateColor(buttonColor) ? palette.sealBlue : palette.red,
              }}
            />
            <input
              type="text"
              value={buttonColor}
              onChange={(e) => {
                const color = e.target.value;
                setButtonColor(color);
              }}
              css={{
                margin: 0,
                padding: 8,
                border: "solid 1px",
                borderColor: validateColor(buttonColor) ? palette.sealBlue : palette.red,
                borderRadius: 2,
                height: 30,
                width: 220,
                marginLeft: 5,
              }}
            />
          </div>
        </div>

        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>Button Text color</span>
          <div
            css={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <input
              type="color"
              value={buttonTextColor}
              onChange={(e) => {
                setButtonTextColor(e.target.value);
              }}
              css={{
                height: 30,
                width: 60,
                border: "solid 1px",
                borderColor: validateColor(buttonTextColor) ? palette.sealBlue : palette.red,
              }}
            />
            <input
              type="text"
              value={buttonTextColor}
              onChange={(e) => {
                const color = e.target.value;
                setButtonTextColor(color);
              }}
              css={{
                margin: 0,
                padding: 8,
                border: "solid 1px",
                borderColor: validateColor(buttonTextColor) ? palette.sealBlue : palette.red,
                borderRadius: 2,
                height: 30,
                width: 220,
                marginLeft: 5,
              }}
            />
          </div>
        </div>

        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>Button Border color</span>
          <div
            css={{
              display: "flex",
              flexDirection: "row",
            }}
          >
            <input
              type="color"
              value={buttonBorderColor}
              onChange={(e) => {
                setButtonBorderColor(e.target.value);
              }}
              css={{
                height: 30,
                width: 60,
                border: "solid 1px",
                borderColor: validateColor(buttonBorderColor) ? palette.sealBlue : palette.red,
              }}
            />
            <input
              type="text"
              value={buttonBorderColor}
              onChange={(e) => {
                const color = e.target.value;
                setButtonBorderColor(color);
              }}
              css={{
                margin: 0,
                padding: 8,
                border: "solid 1px",
                borderColor: validateColor(buttonBorderColor) ? palette.sealBlue : palette.red,
                borderRadius: 2,
                height: 30,
                width: 220,
                marginLeft: 5,
              }}
            />
          </div>
        </div>

        <div
          css={{
            display: "grid",
            alignItems: "center",
            gridTemplateColumns: "1fr",
            gridRowGap: 4,
          }}
        >
          <span>Button Width (%)</span>

          <input
            type="text"
            placeholder="Insert Button Width"
            value={buttonWidth}
            onChange={(e) => {
              setButtonWidth(e.target.value);
            }}
            css={{
              margin: 0,
              padding: 8,
              border: "solid 1px",
              borderColor: validateButtonWidth(buttonWidth) ? palette.sealBlue : palette.red,
              borderRadius: 2,
            }}
          />
        </div>

        <div
          css={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <span>Target: "_blank"</span>

          <input type="checkbox" name="targetBlank" defaultChecked={true} />
        </div>

        <button
          type="submit"
          disabled={!validateForm(buttonText, buttonURL, buttonColor, buttonTextColor, buttonBorderColor, buttonWidth)}
          css={{
            margin: 0,
            padding: 8,
            border: "none",
            borderRadius: 4,
            cursor: "pointer",
          }}
        >
          Insert
        </button>
      </form>
    </div>
  );
}

CustomButtonInput.propTypes = {
  onInsert: PropTypes.func.isRequired,
};

function validateForm(buttonText, buttonURL, buttonColor, buttonTextColor, buttonBorderColor, buttonWidth) {
  return (
    validateText(buttonText) &&
    validateUrl(buttonURL) &&
    validateColor(buttonColor) &&
    validateColor(buttonTextColor) &&
    validateColor(buttonBorderColor) &&
    validateButtonWidth(buttonWidth)
  );
}
